var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { Box } from 'modules/v2/foundation/Box';
import { Typography } from 'modules/v2/foundation/Typography';
import { Avatar } from '../Avatar';
import { CardHeaderContainer, CardHeaderTextContainer, CardHeaderContent } from './styled';
export const CardHeader = forwardRef((props, forwardedRef) => {
    const { action, title, subtitle, children, icon, appearance, className } = props, rest = __rest(props, ["action", "title", "subtitle", "children", "icon", "appearance", "className"]);
    return (<CardHeaderContainer className={className} ref={forwardedRef} {...rest}>
      <CardHeaderContent>
        {icon && (<Avatar size="md" shape="square" appearance={appearance || 'light'}>
            {icon}
          </Avatar>)}
        <CardHeaderTextContainer>
          {title && (<Typography $appearance="300" $fontSize="medium" $lineHeight="neutralized" $fontWeight="medium">
              {title}
            </Typography>)}
          {subtitle && (<Typography $appearance="100" $fontSize="small" $lineHeight="neutralized" $fontWeight="regular">
              {subtitle}
            </Typography>)}
        </CardHeaderTextContainer>
        {action && <Box ml="auto">{action}</Box>}
      </CardHeaderContent>
      {children}
    </CardHeaderContainer>);
});
